"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../utils");

var _Title = _interopRequireDefault(require("../../Title"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

function PictureComponent(props) {
  var imageSrc = props.imageSrc;

  var _a = (0, _utils.fomateFileData)(imageSrc),
      url = _a.url,
      _b = _a.alt,
      alt = _b === void 0 ? '' : _b;

  var _c = (0, _react.useState)({}),
      styles = _c[0],
      setStyls = _c[1];

  (0, _react.useEffect)(function () {
    var imgLoad = new Image();

    if (url) {
      imgLoad.src = url;
    }

    imgLoad.onload = function () {
      var collectStyles = {};

      if (imgLoad.width < imgLoad.height) {
        collectStyles = {
          height: '100%',
          width: 'auto'
        };
      } else {
        collectStyles = {
          height: 'auto'
        };
      }

      setStyls(collectStyles);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("img", {
    style: __assign({
      maxHeight: '54px'
    }, styles),
    src: url,
    alt: alt
  });
}

var Article = function Article(props) {
  var source = props.source,
      record = props.record,
      onCallbackHandle = props.onCallbackHandle,
      className = props.className,
      hrefText = props.hrefText,
      href = props.href,
      title = props.title,
      article = props.article,
      index = props.index,
      cardStyle = props.cardStyle;
  var titleRef = (0, _react.useRef)();

  var _a = (0, _react.useState)(false),
      limitHeight = _a[0],
      setLimitHeight = _a[1];

  (0, _react.useEffect)(function () {
    var _a;

    if (((_a = titleRef === null || titleRef === void 0 ? void 0 : titleRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) > 24) {
      setLimitHeight(true);
    }
  }, [titleRef]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-default-article', className),
    "report-event": "click_customerDescription_href",
    "report-ext1": index,
    "report-ext2": hrefText || '',
    "report-ext3": href || '',
    onClick: function onClick() {
      if (!href) return;
      window.location.href = href;
    },
    style: cardStyle ? __assign({}, cardStyle) : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-default-article-container')
  }, /*#__PURE__*/_react["default"].createElement("section", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, source ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '16px',
      width: '160px',
      height: '54px'
    }
  }, /*#__PURE__*/_react["default"].createElement(PictureComponent, {
    imageSrc: source
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '16px',
      width: '160px',
      height: '54px'
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: 'https://staticintl.cloudcachetci.com/cms/backend-cms/rQmv565_Frame%20117.png',
    style: {
      height: '100%',
      width: 'auto'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      wordBreak: 'break-word'
    },
    onClick: function onClick() {
      onCallbackHandle === null || onCallbackHandle === void 0 ? void 0 : onCallbackHandle(record);
    }
  }, title && /*#__PURE__*/_react["default"].createElement("strong", {
    className: 'wordBreak lineBreak',
    ref: titleRef
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('div-content', {
      'div-content-height': limitHeight
    }),
    dangerouslySetInnerHTML: {
      __html: article || ''
    }
  }), href ? /*#__PURE__*/_react["default"].createElement("a", {
    className: 'flex-default-article_a',
    href: href,
    "report-event": "click_customerDescription_href",
    "report-ext1": index,
    "report-ext2": hrefText || '',
    "report-ext3": href || ''
  }, hrefText || "Learn more ", " >") : /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-default-article-empty"
  })))));
};

var CustomerComponent = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var style = props.style,
      flexTitle = props.flexTitle,
      desc = props.desc,
      _a = props.lightTheme,
      lightTheme = _a === void 0 ? false : _a,
      mergeComponentStatus = props.mergeComponentStatus,
      flexSmallTitle = props.flexSmallTitle,
      configuration = props.configuration,
      filterOptions = props.filterOptions,
      // 分页+筛选 容器参数
  onClick = props.onClick,
      restProps = __rest(props, ["style", "flexTitle", "desc", "lightTheme", "mergeComponentStatus", "flexSmallTitle", "configuration", "filterOptions", "onClick"]);

  var compatibleArr = (configuration === null || configuration === void 0 ? void 0 : configuration.length) && __spreadArrays(configuration);

  var numLenThree = [5].includes(configuration.length) || configuration.length % 3 == 0;
  var numLenTwo = [2].includes(configuration.length);
  var numLenFour = [4].includes(configuration.length) || configuration.length > 6 && configuration.length % 3 != 0;

  if (numLenThree && configuration.length === 5) {
    compatibleArr = __spreadArrays(configuration, [{}]);
  }

  if (numLenFour) {
    var fill = new Array(Math.ceil(configuration.length / 4) * 4 - configuration.length).fill({});
    compatibleArr = __spreadArrays(configuration, fill);
  } // 纵向筛选器 每行最多展示3长卡片


  if (filterOptions && Object.keys(filterOptions).length > 0 && filterOptions.direction === 'col' && compatibleArr.length > 2) {
    numLenFour = false;
    numLenThree = true;

    if (compatibleArr.length % 3 !== 0) {
      compatibleArr = __spreadArrays(compatibleArr, new Array(3 - compatibleArr.length % 3).fill({}));
    }
  }

  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref
  }, restProps, {
    className: (0, _classnames["default"])('flex-default-customers Customers', {
      'flex-default-customers-except': filterOptions && Object.keys(filterOptions).length > 0
    }),
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-default-customers-children', {
      'flex-default-not-title-container-box': (filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.direction) === 'col'
    })
  }, flexTitle ? /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    lightTheme: lightTheme,
    title: flexTitle,
    desc: desc,
    mergeComponentStatus: mergeComponentStatus,
    flexSmallTitle: flexSmallTitle
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-default-customers-article', {
      'flex-default-customers-article-box': (filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.direction) === 'col'
    })
  }, compatibleArr === null || compatibleArr === void 0 ? void 0 : compatibleArr.map(function (item, index) {
    var content = item.content,
        title = item.title,
        href = item.href,
        source = item.source,
        hrefText = item.hrefText,
        cardStyle = item.cardStyle;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex-default-customers-article__list', {
        'flex-default-customers-article__list--three': numLenThree,
        'flex-default-customers-article__list--four': numLenFour,
        'flex-default-customers-article__list--two': numLenTwo
      }),
      key: index
    }, title && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('customer-img-container', {
        'customer-img-container--hover': href && hrefText
      }),
      style: (cardStyle === null || cardStyle === void 0 ? void 0 : cardStyle.border) ? {
        border: 'none'
      } : {}
    }, /*#__PURE__*/_react["default"].createElement(Article, {
      record: item || {},
      article: content,
      title: title,
      href: href,
      hrefText: hrefText,
      source: source,
      index: index,
      cardStyle: cardStyle
    })));
  }))));
});
CustomerComponent.displayName = 'TCICustomerComponent';
var _default = CustomerComponent;
exports["default"] = _default;